import _ from 'underscore';
import { mapState } from 'vuex';

import f from "@/application/shared/functions.js"

import search from "@/components/modules/app/activity/search/index.vue"
import themeToggle from "@/components/assets/themetoggle/index.vue"

export default {
    name: 'activity',
    props: {
        searchvalue : String,
        mixgroup : Object,
        loading : Boolean
    },

    components : {
        search, themeToggle
    },

    data : function(){

        return {
            history : []
        }

    },

    created(){
        this.history = this.core.activity.history
    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,

        grouped : function(){
          
            return f.group(this.filtered, (h) => {
                return h.type
            })

        },

        empty : function(){
            if(_.isEmpty(this.mixgrouped)) return true

            return null
        },


        mixgrouped : function(){

            var mixed = {}

            _.each(this.mixgroup, (g, i) => {
                mixed[i] || (mixed[i] = [])

                mixed[i] = mixed[i].concat(g)
            })

            _.each(this.grouped, (g, i) => {
                mixed[i] || (mixed[i] = [])

                mixed[i] = mixed[i].concat(g)
            })


            _.each(mixed, (g, i) => {
                mixed[i] = _.uniq(g, (o) => {
                    return o.index
                })
            })


            return mixed
        },

        filtered : function(){
            var h = this.history

            if (this.searchvalue){
                h = this.core.activity.search(this.searchvalue)
            }

            return h
        }
    }),

    methods : {
        reload : function(){

            this.history = this.core.activity.history
        },
        getmodule : function(item){
            
            if(item.type == 'search') return search
            
            if (item.type == 'setting'){
                if(item.key == 'settingtheme') return themeToggle
            }

            return def
            
        },

        open : function(item){

            if (item.link){

                this.$router.push(item.link).catch(e => {})

                this.$emit('close')
            }

            if (item.action){
                if (item.action.search){
                    this.$emit('search', item.action.search)
                }

                if (item.action.vueapi){
                    this.core.vueapi[item.action.vueapi](item.data)
                }

                
            }
        },

        to : function(path){
            this.$router.push(path).catch(e => {})

            this.$emit('close')
        }
    },
}